/* eslint-disable consistent-return */ // eslint-disable-next-line import/no-extraneous-dependencies
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
import { eligibleProductOptionsForRestriction, isSpecialVersion3dot5 } from 'shared/helpers/specials-3-5';
import { getAvailableQuantity, isApplicableItem, mergeSatisfiers } from './common';
import { orderProductsForDiscountPrecedence, getRemainingRewardsQuantity, compareRewards } from '../utilities';
var isEligibleWeight = function(reward, item) {
    return _.isNil(reward.weight) || reward.weight === 'Any Weight' || item.option === reward.weight;
};
var issueStandardRewards = function(bogoCalcsData, bogoSpecial, conditionsManager, items) {
    var bogoRewardLogicOperator = bogoSpecial.bogoRewardLogicOperator, bogoRewards = bogoSpecial.bogoRewards, specialId = bogoSpecial.specialId, totalSpend = bogoSpecial.totalSpend;
    var rewardsSatisfiers = {};
    var rewardsInProgress = {};
    var sortedItems = orderProductsForDiscountPrecedence(items, conditionsManager.specialsSettings, 'rewards');
    var finishedSatisfyingRewards = false;
    var remainingSatisfiersCount = getRemainingRewardsQuantity(bogoRewards);
    _.forEach(sortedItems, function(item) {
        _.forEach(bogoRewards || [], function(reward) {
            var satisfierFieldToUse = bogoRewardLogicOperator === 'or' ? reward._id : 'total';
            var isApplicable = false;
            var isApplicableWeight = false;
            if (isSpecialVersion3dot5(bogoSpecial)) {
                var _eligibleProductOptionsForRestriction;
                if ((((_eligibleProductOptionsForRestriction = eligibleProductOptionsForRestriction(item, reward, 'inclusion', bogoSpecial)) === null || _eligibleProductOptionsForRestriction === void 0 ? void 0 : _eligibleProductOptionsForRestriction.length) || 0) > 0) {
                    isApplicable = true;
                    isApplicableWeight = true;
                }
            } else {
                isApplicable = isApplicableItem(reward, item, bogoSpecial, "reward");
                isApplicableWeight = isEligibleWeight(reward, item);
            }
            if (isApplicable && isApplicableWeight) {
                var _conditionsManager_satisfiers_item_key, _conditionsManager_satisfiers, // Don't reshuffle if defeated rewards would make it impossible
                _bogoCalcsData_defeatedRewardsSatisfiers_item_key, _bogoCalcsData_defeatedRewardsSatisfiers, __find;
                var _conditionsManager_satisfiers_item_key_quantity;
                var itemsUsedForConditions = (_conditionsManager_satisfiers_item_key_quantity = (_conditionsManager_satisfiers = conditionsManager.satisfiers) === null || _conditionsManager_satisfiers === void 0 ? void 0 : (_conditionsManager_satisfiers_item_key = _conditionsManager_satisfiers[item.key]) === null || _conditionsManager_satisfiers_item_key === void 0 ? void 0 : _conditionsManager_satisfiers_item_key.quantity) !== null && _conditionsManager_satisfiers_item_key_quantity !== void 0 ? _conditionsManager_satisfiers_item_key_quantity : 0;
                // TODO: optimize how reshuffling occurs
                var attemptConditionShuffle = itemsUsedForConditions > 0 && (((_bogoCalcsData_defeatedRewardsSatisfiers = bogoCalcsData.defeatedRewardsSatisfiers) === null || _bogoCalcsData_defeatedRewardsSatisfiers === void 0 ? void 0 : (_bogoCalcsData_defeatedRewardsSatisfiers_item_key = _bogoCalcsData_defeatedRewardsSatisfiers[item.key]) === null || _bogoCalcsData_defeatedRewardsSatisfiers_item_key === void 0 ? void 0 : _bogoCalcsData_defeatedRewardsSatisfiers_item_key.quantity) || 0) < item.quantity;
                if (attemptConditionShuffle) {
                    conditionsManager.evaluate({
                        itemToConsiderLast: item,
                        pendingRewardsSatisfiers: rewardsSatisfiers
                    });
                }
                var availableQuantity = getAvailableQuantity({
                    item: item,
                    bogoCalcsData: bogoCalcsData,
                    pendingConditionsSatisfiers: conditionsManager.satisfiers,
                    pendingRewardsSatisfiers: rewardsSatisfiers,
                    excludeDefeatedRewardsSatisfiers: true,
                    totalSpendApplicable: totalSpend === null || totalSpend === void 0 ? void 0 : totalSpend.enabled
                });
                var previouslySatisfied = _.flatMap(_.values(rewardsSatisfiers), 'rewards');
                var isRewardAlreadySatisfied = !!((__find = _.find(previouslySatisfied, reward._id)) === null || __find === void 0 ? void 0 : __find[reward._id].satisfied);
                if (availableQuantity > 0 && !isRewardAlreadySatisfied) {
                    rewardsInProgress[reward._id] = _object_spread_props(_object_spread({}, rewardsInProgress[reward._id]), {
                        total: remainingSatisfiersCount[satisfierFieldToUse]
                    });
                    var amountAwarded = Math.min(availableQuantity, remainingSatisfiersCount[satisfierFieldToUse]);
                    remainingSatisfiersCount[satisfierFieldToUse] -= amountAwarded;
                    rewardsSatisfiers = mergeSatisfiers(rewardsSatisfiers, _define_property({}, item.key, {
                        item: item,
                        quantity: amountAwarded,
                        rewards: _define_property({}, reward._id, {
                            quantity: amountAwarded,
                            reward: _object_spread({}, reward),
                            specialId: specialId,
                            satisfied: remainingSatisfiersCount[satisfierFieldToUse] < 1,
                            discountStacking: bogoSpecial.discountStacking,
                            discountPrecedence: bogoSpecial.discountPrecedence,
                            stackingBehavior: bogoSpecial.stackingBehavior,
                            nonStackingBehavior: bogoSpecial.nonStackingBehavior,
                            settingsDerivedFrom: bogoSpecial.settingsDerivedFrom
                        })
                    }));
                    rewardsInProgress[reward._id] = _object_spread_props(_object_spread({}, rewardsInProgress[reward._id]), {
                        remaining: remainingSatisfiersCount[satisfierFieldToUse],
                        satisfied: remainingSatisfiersCount[satisfierFieldToUse] < 1
                    });
                } else if (attemptConditionShuffle) {
                    conditionsManager.revert();
                }
            }
            if (remainingSatisfiersCount[satisfierFieldToUse] < 1) {
                finishedSatisfyingRewards = true;
                return false; // breaks early
            }
        });
        if (finishedSatisfyingRewards) {
            return false;
        }
    });
    // compareRewards filters out partial rewards for fully satisfied ones
    // in the case of multiple possible rewards and 'OR' specials
    return bogoRewardLogicOperator === 'or' ? compareRewards(rewardsSatisfiers, rewardsInProgress) : rewardsSatisfiers;
};
export default issueStandardRewards;
